export const mockJobs = [
  {
    id: 1,
    title: 'Industriemechaniker (m/w/d)',
    location: 'Hamburg',
    type: 'Vollzeit',
    category: 'Gewerblich',
    date: 'Vor 2 Tagen',
    salary: 'ab 18,50 € / Std.',
    desc: 'Für unseren namhaften Kunden aus dem Maschinenbau in Hamburg suchen wir ab sofort einen Industriemechaniker (m/w/d). Sie montieren Baugruppen nach Zeichnung und führen Qualitätskontrollen durch.',
    requirements: ['Abgeschlossene Ausbildung als Industriemechaniker','Berufserfahrung in der Montage','Schichtbereitschaft (2-Schicht)'],
    germanLevel: 'B1',
    accommodation: 'Nein'
  },
  {
    id: 2,
    title: 'Pflegefachkraft (m/w/d)',
    location: 'Bremen',
    type: 'Vollzeit / Teilzeit',
    category: 'Pflege',
    date: 'Heute',
    salary: 'ab 3.200 € Brutto',
    desc: 'Zur Verstärkung eines modernen Pflegeheims suchen wir engagierte Pflegefachkräfte. Auch internationale Bewerber mit laufender Anerkennung sind willkommen!',
    requirements: ['Abgeschlossene Ausbildung in der Pflege','Empathie und Zuverlässigkeit','Bereitschaft zum Schichtdienst'],
    germanLevel: 'B2 (bei Anerkennung B1 ok)',
    accommodation: 'Ja, für die ersten 3 Monate möglich'
  },
  {
    id: 3,
    title: 'Staplerfahrer (m/w/d)',
    location: 'Kiel',
    type: 'Vollzeit / Schicht',
    category: 'Logistik',
    date: 'Vor 1 Woche',
    salary: '14,50 € / Std.',
    desc: 'Für ein großes Logistikzentrum suchen wir routinierte Staplerfahrer. Sie be- und entladen LKW und lagern Waren mittels Schubmaststapler ein.',
    requirements: ['Gültiger Staplerschein','Erfahrung im Umgang mit Schubmaststaplern','Zuverlässige Arbeitsweise'],
    germanLevel: 'A2',
    accommodation: 'Nein'
  },
  {
    id: 4,
    title: 'Elektroingenieur (m/w/d)',
    location: 'Lübeck',
    type: 'Vollzeit',
    category: 'Ingenieurwesen',
    date: 'Vor 3 Tagen',
    salary: 'Nach Vereinbarung',
    desc: 'International agierendes Technologieunternehmen sucht Verstärkung in der Hardware-Entwicklung. Ideal für internationale Fachkräfte.',
    requirements: ['Abgeschlossenes Studium der Elektrotechnik','Erfahrung im Schaltungsdesign','Gute Englischkenntnisse'],
    germanLevel: 'B2',
    accommodation: 'Unterstützung bei der Wohnungssuche'
  }
];

export const mockProfiles = [
  {
    id: 'B-84729',
    profession: 'CNC-Fräser / Zerspanungsmechaniker',
    industry: 'Handwerk / Industrie',
    experience: '8 Jahre Berufserfahrung im Bereich Einzelteilfertigung',
    qualifications: ['Abgeschlossene Berufsausbildung', 'Heidenhain & Siemens Steuerung', 'Kranführerschein'],
    languages: 'Deutsch (C1), Englisch (A2), Türkisch (Muttersprache)',
    location: 'Raum Hamburg (+30km)',
    availability: 'Ab 01. Nächster Monat',
    drivingLicense: 'Klasse B, eigener PKW',
    shortProfile: 'Zuverlässiger und präzise arbeitender CNC-Fräser mit fundierter Erfahrung in der Programmierung und Einrichtung von 3- und 5-Achs-Fräsmaschinen. Sucht eine langfristige Perspektive im Schichtbetrieb.',
    avgs: 'AVGS vorhanden'
  }
];